import { z } from "zod";

export const UserSchema = z.object({
	id: z.number(),
	username: z.string(),
	isActive: z.boolean(),
	firstName: z.string(),
	lastName: z.string(),
	email: z.string().email(),
	phoneNumber: z.string(),
	roleId: z.number(),
	cognitoId: z.string().nullable(),
	timezone: z.string().default("America/New_York"),
	ssn: z.string().nullable(),
	v2RoleId: z.number().nullable(),
	impersonatedUserId: z.number().nullable(),
	impersonatedCaregiverId: z.number().nullable(),
	impersonatedClientId: z.number().nullable(),
	impersonatedTrustedContactId: z.number().nullable(),
	adpFileNumber: z.string().nullable(),
	payRate: z.number().nonnegative().max(100).nullable(),
	chatId: z.string().uuid(),
	chatEnabled: z.boolean().default(true),
	chatSmsEnabled: z.boolean().default(true),
	chatEmailEnabled: z.boolean().default(false),
	cognitoSyncStatus: z.enum(["pending", "success", "error"]).nullable(),
	cognitoSyncError: z.string().nullable(),
	mfaPreferredMethod: z.enum(["SMS_MFA", "SOFTWARE_TOKEN_MFA"]).nullable(),
	pushNotificationDeviceToken: z.string().nullable(),
	snsPlatformEndpointArn: z.string().nullable(),
});

export type UserType = z.infer<typeof UserSchema>;

export const CreateUserSchema = UserSchema.pick({
	firstName: true,
	lastName: true,
	email: true,
	phoneNumber: true,
	isActive: true,
	timezone: true,
	ssn: true,
	payRate: true,
}).extend({
	adpFileNumber: z
		.string()
		.regex(/^\d{6}$/, "Must be 6 digits")
		.or(z.literal(""))
		.nullable()
		.optional()
		.transform((v) => (v === "" ? null : (v ?? null))),
	v2RoleId: z
		.number()
		.nonnegative()
		.refine((id) => id !== 4 && id !== 3, {
			message: "Invalid role",
		}),
});

export type CreateUserType = z.infer<typeof CreateUserSchema>;
